import { render, staticRenderFns } from "./createRequestItem.vue?vue&type=template&id=6f5ef2c6&scoped=true"
import script from "./createRequestItem.vue?vue&type=script&lang=js"
export * from "./createRequestItem.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./createRequestItem.vue?vue&type=style&index=1&id=6f5ef2c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5ef2c6",
  null
  
)

export default component.exports